;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	Model.LoginFormBuilder = Model.LoginFormBuilder.extend({
		defaults: {
			layout_login: 'LoginFormLeft',
			layout_password_recovery: 'LoginFormLeft',
			layout_send_token: 'LoginFormLeft',
			side_bar_enabled: false,
			side_bar_widgets: ['Promo','Steps'],
			game: 'Tipping',
			client: 'Club'
		}
	});

}(window, APP, Backbone, Marionette, $, _));